import {
    Anchor,
    Code,
    Group,
    Stack,
    Table,
    Text,
    Tooltip,
} from '@mantine/core';
import {NavLink} from 'react-router-dom';
import {AiOutlineEnter} from 'react-icons/ai';

import {
    OutcomeBadge,
    VerificationBadge,
} from '../../test-observations/profile/Badges';
import {CascadeRow} from '../../test-observations/utils/cascadeRows';
import {formatTimestamp} from '../../../utils/TableTimestamps.tsx';

// Compact observation list for the synthetic-user detail page. Deliberately the same
// cascade shape as the main table — indented, muted dependents directly beneath the
// failure that blocked them — so an operator learns one reading of a cascade, not two.
export const ObservationsMiniTable = ({rows}: { rows: CascadeRow[] }) => {

    return (
        <Table.ScrollContainer minWidth={640}>
            <Table verticalSpacing={'xs'} highlightOnHover>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>Action</Table.Th>
                        <Table.Th>Outcome</Table.Th>
                        <Table.Th>Verification</Table.Th>
                        <Table.Th>Observed</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {rows.map((row) => (
                        <Table.Tr key={row.record.id}>
                            <Table.Td>
                                <Group gap={'xs'} wrap={'nowrap'} pl={row.depth * 20}>
                                    {row.depth > 0 && (
                                        <Tooltip label={`Blocked by ${row.blockedBy.join(', ')}`} withArrow>
                                            <Text c={'dimmed'} span>
                                                <AiOutlineEnter style={{transform: 'rotate(-90deg)'}}/>
                                            </Text>
                                        </Tooltip>
                                    )}
                                    <Anchor
                                        component={NavLink}
                                        to={`/test-observations/${encodeURIComponent(row.record.id)}`}
                                    >
                                        <Code c={row.muted ? 'dimmed' : undefined}>{row.record.actionCode}</Code>
                                    </Anchor>
                                </Group>
                            </Table.Td>
                            <Table.Td>
                                <Stack gap={2}>
                                    <OutcomeBadge record={row.record} kind={row.kind}/>
                                    {row.childCount > 0 && (
                                        <Text size={'xs'} c={'red'}>
                                            {`blocked ${row.childCount} ${row.childCount === 1 ? 'action' : 'actions'}`}
                                        </Text>
                                    )}
                                </Stack>
                            </Table.Td>
                            <Table.Td>
                                <VerificationBadge verificationResult={row.record.verificationResult}/>
                            </Table.Td>
                            <Table.Td>
                                <Text size={'xs'} c={'dimmed'}>{formatTimestamp(row.record.observedAt)}</Text>
                            </Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
        </Table.ScrollContainer>
    );
};
